import React from "react";
import Aux from "../utils/AuxFunctions";
import "./Account.css"
import Fire from "../config/Fire";
import ButtonLoader from "../utils/Utilities/ButtonLoader"
import { withMyDataContext } from "../context/DataProvider";
import Colors from "../utils/Colors";
import ShareModal from "../utils/Utilities/ShareModal";
import NotLoggedIn from "../utils/ErrorPages/NotLoggedIn";
import ContentCopyIcon from "mdi-react/ContentCopyIcon"
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import SucessMessage from "../utils/ErrorPages/SucessMessage";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import LoadingHelper from "../utils/Utilities/LoadingHelper";
class InviteFriends extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            creatingLinkError: "",
            isCreatingLink:false,
            sucess:false,
            openShareModal: false,
            loginDialog: false,
        }
        this.shareText = "Create an account and get 10$"
        this.shareHashtag = "Richless"
        // this.shareUrl = "https://richless.page.link/" + this.props.myDataProvider.user.linkId
    }


    componentDidMount() {
        try {

        } catch (error) {
            console.error(error)
        }
        //console.log(this.props.post)
    }

    copyToClipboard = (e) => {
        this.textArea.select();
        document.execCommand('copy');
        // This is just personal preference.
        // I prefer to not show the whole text area selected.
        e.target.focus();
        //this.setState({ copySuccess: 'Copied!' });
    };

    CreateMyLink = async() => {
        try{
            this.setState({isCreatingLink:true, creatingLinkError: ""})
            await Fire.shared.CreateMyLink(Fire.shared.uid);
            this.setState({isCreatingLink:false, sucess:true})
        }catch(error){
            console.error(error);
            this.setState({isCreatingLink:false, creatingLinkError: "An unexpected error has occurred"})
        }
    }

    goBack = () => {
        try {
            this.props.history.goBack()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    render() {

        return (
            <div style={{width:"100%"}}>
            <div className="container" >

                <NotLoggedIn active={this.state.loginDialog} onClose={() => this.setState({ loginDialog: false })}></NotLoggedIn>
                <div>
                    <div className="reversed-button-hover" style={{display:"flex", alignItems:"center",}} onClick={this.goBack}>
                        <ChevronLeftIcon style={{marginRight:5}}></ChevronLeftIcon>
                        <h2>Invite Friends</h2>
                    </div>
                    {this.props.myDataProvider.user ?

                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <ShareModal active={this.state.openShareModal} onClose={() => this.setState({ openShareModal: !this.state.openShareModal })} title="Share your link" text={this.shareText} url={"https://richless.page.link/" + this.props.myDataProvider.user.linkId} image={null} hashtag={this.shareHashtag} />
                            <div style={{ display: "flex", alignItems: "center", flexDirection: "column", margin: "20px 0", textAlign: "center" }}>
                                <img alt="logo" src={Aux.GiftBox} style={{ width: 80, objectFit: "contain", marginBottom: 20 }}></img>

                                <h3 style={{margin:"10px 0"}}>Invite your friends and both of you will earn <span style={{ color: Colors.green }}>10$</span>!</h3>
                                <span style={{ color: Colors.softText }}>Copy the link below and send to your friends to earn money!</span>
                                
                                <SucessMessage active={this.state.sucess} text="You've successfully created a link"></SucessMessage>
                            </div>
                            {/* <div style={{ display: "flex", }}>
                            <span  style={{color: Colors.softText}} classname="text-hover" onClick={this.copyToClipboard}>click here to copy link</span>
                            <ButtonLoader
                                text="Copy link"
                                onClick={this.copyToClipboard}
                                style={{ backgroundColor: Colors.softText, width: 100, height: 50 }}
                            />
                        </div> */}
                            {this.props.myDataProvider.user.linkId ? <div>
                                <input ref={(textarea) => this.textArea = textarea} type="text" defaultValue={"https://richless.page.link/" + this.props.myDataProvider.user.linkId} name="text"
                                    className="simple-input" style={{ width: 300, textAlign: "center", outline:"none" }}></input>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <ButtonLoader
                                        text="Share Link"
                                        onClick={() => this.setState({ openShareModal: !this.state.openShareModal })}
                                        style={{ backgroundColor: Colors.mainColor, width: "70%", height: 50 }}
                                    />
                                    <ButtonLoader
                                        icon={ContentCopyIcon}
                                        onClick={this.copyToClipboard}
                                        style={{ backgroundColor: Colors.softText, height: 50, marginLeft: 5, }}
                                    />
                                </div>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                                    <div style={{ display: "flex", flexDirection: "column", borderRadius: 10, borderColor: Colors.softText, borderWidth: 2, justifyContent: "center", alignItems: "center", margin: "10px 0", padding: "20px 10px" }}>
                                        <span style={{ color: Colors.softText, fontSize: 12 }}>Friends invited</span>
                                        <h2 style={{ color: Colors.darkText, fontWeight: "bold", fontSize: 16 }}>{this.props.myDataProvider.statistics.referralCount || 0}</h2>
                                    </div>
                                    <div style={{ display: "flex", flexDirection: "column", borderRadius: 10, borderColor: Colors.softText, borderWidth: 2, justifyContent: "center", alignItems: "center", margin: "10px 0", padding: "20px 10px" }}>
                                        <span style={{ color: Colors.softText, fontSize: 12 }}>Money earned</span>
                                        <h2 style={{ color: Colors.darkText, fontWeight: "bold", fontSize: 16 }}>{this.props.myDataProvider.statistics.referralCoinsTotal || 0}$</h2>
                                    </div>
                                </div>
                            </div> 
                            : 
                            <div style={{display:"flex", flexDirection:"column" ,justifyContent:"center", alignItems:"center"}}>
                                <ErrorMessage text={this.state.creatingLinkError}></ErrorMessage>
                                <h4 style={{marginBottom:10}}>You don't have a link yet.</h4>
                                <span color={Colors.softText}>click below to create one</span>
                                <ButtonLoader
                                    text="Create a link"
                                    loading={this.state.isCreatingLink}
                                    onClick={this.CreateMyLink}
                                    style={{ backgroundColor: Colors.mainColor, height: 50, marginLeft: 5, marginTop:5 }}
                                />
                            </div>
                            }

                        </div>
                        :
                        <LoadingHelper></LoadingHelper>
                    }
                </div>
            </div>
            </div>
        );
    }
}

export default withMyDataContext(InviteFriends);